import { Injectable } from '@angular/core';
import { UsersService } from '@spa/api';

@Injectable()
export class BffUsersService extends UsersService {
  protected getApiUrl(): string {
    return (this as any).moduleConfig.authUrl + '/auth/api/v1/';
  }

  protected getBaseApiUrl(): string {
    return (this as any).moduleConfig.authUrl + '/auth/api/';
  }
}
